class ManageDisclosuresController {
    constructor(_, preFetchedData, adminService, dateTimeService, componentRegistryService, componentDataService, fileSaver, toastr, blobDownloadService) {
        this._ = _;
        this.adminService = adminService;
        this.disclosureList = preFetchedData.disclosureList;
        this.formatDate = dateTimeService.formatDate;
        this.disclosureList.disclosures = this._formatListData(this.disclosureList.disclosures);
        this.disclosureSearchFilters = preFetchedData.disclosureSearchFilters;
        this.statusOptions = this._.filter(preFetchedData.disclosureStatusOptions, (status) => status.id !== "Draft");
        this.disclosureTypes = preFetchedData.disclosureTypeOptions;
        this.facultyOptions = preFetchedData.facultyOptions;
        this.schoolOptions = preFetchedData.schoolOptions;
        this.showCustomSearchFilter = false;
        this.showDisclosureIdSearchFilter = false;
        this.statusList = "";
        this.filter = {
            pageIndex: this.disclosureList.page,
            pageSize: this.disclosureList.pageSize,
            displayId: "", 
            statusList: "", 
            disclosureType: "",
            faculty: "",
            school: ""
        };
        this.newFilter = this._.assign({}, this.filter, {pageIndex: 1});
        this.selectedSearchFilter = this.selectedSearchFilter ? this.selectedSearchFilter : "Default";
        this.componentRegistryService = componentRegistryService;
        this.componentDataService = componentDataService;
        this.fileSaver = fileSaver;
        this.toastr = toastr;
        this.blobDownloadService = blobDownloadService;
    }

    search() {  
        this.filter = this._.assign({}, this.newFilter);

        if (this.validateFilterState()) {
            this.getDisclosureList();
        }        
    }

    download() {
        this.filter = this._.assign({}, this.newFilter);

        if (this.validateFilterState()) {
            this.setFilterState();
            this.blobDownloadService.downloadAllDisclosures(this.filter).then((response) => {
                if (!response.error) {
                    if(response.data) {
                        this.fileSaver.saveAs(response.data, "Disclosures.xlsx");
                    }
                    else {
                        this.toastr.warning("No results for filters.");
                    }   
                }
            });
        }
    }

    getIsuStatusFilters() {
        let defaultStatuses = ""; 
        _.forEach(this.statusOptions, function(value) {
            defaultStatuses = defaultStatuses === "" ? value.id :  defaultStatuses + "," + value.id; 
        });
        return defaultStatuses;
    }

    getDisclosureList() {  
        this.setFilterState();
        this.adminService.getManageDisclosures(this.filter).then((data) => {
            if (!data.error) {
                this.disclosureList = data.data;
                this.disclosureList.disclosures = this._formatListData(this.disclosureList.disclosures);
                this.filter.pageIndex = this.disclosureList.page;
                this.filter.pageSize = this.disclosureList.pageSize;
            } else {            
                this.toastr.error("An error has occurred.");
            }
        });
    }

    validateFilterState() {
        let disclosureIdComponent = this.componentRegistryService.get("displayId");
        return this.selectedSearchFilter === 'DisclosureId' ? disclosureIdComponent.validate() : true;
    }

    setFilterState() {
        if (this.selectedSearchFilter === 'Custom' && this.filter.statusList === "") {
            this.filter.statusList = this.getIsuStatusFilters();
        }

        if (this.selectedSearchFilter === 'DisclosureId') {
            let disclosureIdComponent = this.componentRegistryService.get("displayId");
            this.filter.displayId = disclosureIdComponent.model;          
        }

        if (this.selectedSearchFilter === 'Default') {
            this.filter.statusList = "AssessedPendingIsu,PendingRoAssignment";
        }     
    }

    getDistinctSchoolsByFacultyList(facultyName) {
        if (facultyName) {           
            this.adminService.getSchoolsByFaculty(facultyName).then((response) => {
                if (!response.error) {
                    this.schoolOptions = response.data;
                }
            });
        } else {
            this.adminService.getSchools().then((response) => {
                if (!response.error) {
                    this.schoolOptions = response.data;
                }
            });
        }      
    }

    _formatListData(disclosures) {
        return this._.map(disclosures, (disclosure) => {
            return {
                id: disclosure.id,
                displayId: disclosure.displayId ? disclosure.displayId : 'Pending',
                name: disclosure.discloserFullName,
                staffID: disclosure.discloserId,
                status: disclosure.status,
                type: disclosure.type,
                submittedDate: this.formatDate(disclosure.dateSubmitted),
                path: `/admin/${disclosure.type === 'Conflict' ? 'conflictofinterest' : 'gift'}/review/${disclosure.id}`
            }   
        });
    }

    toggleFilter(searchFilterPanel) {
        this.newFilter = {
            pageIndex: 1,
            pageSize: this.disclosureList.pageSize,
            displayId: "", 
            statusList: "", 
            disclosureType: "",
            faculty: "",
            school:""
        };

        if (searchFilterPanel === 'Default') {
            this.newFilter.statusList = "AssessedPendingIsu,PendingRoAssignment";
            this.showCustomSearchFilter = false;
            this.showDisclosureIdSearchFilter = false;
        }

        if (searchFilterPanel === 'DisclosureId') {
            this.showCustomSearchFilter = false;
            this.showDisclosureIdSearchFilter = true;
        }

        if (searchFilterPanel === 'Custom') {
            this.showDisclosureIdSearchFilter = false;
            this.showCustomSearchFilter = true;
        }
    }
}

ManageDisclosuresController.$inject = ['_', 'preFetchedData', 'adminService', 'dateTimeService', 'componentRegistryService', 'componentDataService', 'FileSaver', 'toastr', 'blobDownloadService'];

export default ManageDisclosuresController;


// WEBPACK FOOTER //
// ./app/admin/manage-disclosures.controller.js